import { withStyles, WithStyles, StyleRulesCallback, Theme, Typography } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { required, Validator } from '../../../shared/validation';
import FormTextField from '../../../components/FormTextField';
import { Field } from 'redux-form';
import { BpM } from '../../../shared/brakepoints';
import Translator from '../../../components/Translator';
import { defaultMemoize } from 'reselect';
import FormSelectField from '../../../components/FormSelectField';

type CssClasses = 'fieldContainer' | 'fullRow' | 'halfRow';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  fieldContainer: {
    display: 'flex',
    flexFlow: 'column',
    '& > *': {
      flex: '0 0 100%',
    },
    [BpM()]: {
      display: 'flex',
      margin: '0px -5px 0px',
      width: '500px',
      flexFlow: 'row wrap',
      '& > *': {
        flex: '0 0 250px',
        paddingLeft: '5px',
        paddingRight: '5px',
        maxWidth: '250px',
      },
    },
  },
  fullRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
  },
  halfRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
    [BpM()]: {
      '& > *': {
        width: '250px',
        paddingRight: '10px',
      },
    },
  },
});

interface Props {}

class HuesgesContactFormData extends React.Component<Props & WithStyles<CssClasses>> {
  private translatedRequire = defaultMemoize((translation: string) => {
    return required(translation);
  });

  private justRequired = defaultMemoize((requiredValidator: Validator) => {
    return [requiredValidator];
  });

  render() {
    let { classes } = this.props;
    return (
      <Translator>
        {translate => {
          const req = this.translatedRequire(translate('missing'));
          const justRequired = this.justRequired(req);
          return (
            <>
              <Typography variant={'h6'}>{translate('inspectionContactDataTitle')}</Typography>

              <div className={classes.fieldContainer}>
                <div className={classes.halfRow}>
                  <Field
                    name="salutation"
                    requireMark
                    component={FormSelectField}
                    validate={justRequired}
                    label={translate('title')}
                    fullWidth={false}
                    options={[
                      { value: '', text: translate('pleaseSelect') },
                      { value: 'Herr', text: translate('mr') },
                      { value: 'Frau', text: translate('mrs') },
                    ]}
                  />
                </div>
                <Field
                  name="firstName"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('firstName')}
                  fullWidth={true}
                />
                <Field
                  name="lastName"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('lastName')}
                  fullWidth={true}
                />

                <Field
                  name="street"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('street')}
                  fullWidth={true}
                />
                <Field
                  name="houseNumber"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('housenumber')}
                  fullWidth={true}
                />
                <Field
                  name="zipCode"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('zipCode')}
                  fullWidth={true}
                />
                <Field
                  name="city"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('city')}
                  fullWidth={true}
                />
                <div className={classes.fullRow}>
                  <Field
                    name="phoneNumber"
                    requireMark
                    component={FormTextField}
                    validate={justRequired}
                    label={translate('phonenumber')}
                    fullWidth={false}
                  />
                </div>
                <div className={classes.fullRow}>
                  <Field
                    name="mail"
                    requireMark
                    component={FormTextField}
                    validate={justRequired}
                    label={translate('mail')}
                    fullWidth={false}
                  />
                </div>
              </div>
            </>
          );
        }}
      </Translator>
    );
  }
}

export default pure(withStyles(styles)(HuesgesContactFormData));



// WEBPACK FOOTER //
// ./src/routes/inspection/container/HuesgesContactFormData.tsx